import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';
import addReadWriteRecipients from 'owa-readwrite-recipient-well/lib/actions/addReadWriteRecipients';

export default action('addSelectedRecipientToWell')(function addSelectedRecipientToWell(
    viewState: AtMentionsViewState,
    targetRecipientWell: RecipientWellWithFindControlViewState,
    newPersona: FindRecipientPersonaType = null
) {
    if (!newPersona) {
        newPersona = viewState.findResultSet[viewState.selectedRecipientIndex];
    }

    const recipientData = { isValid: true, newPersona };
    addReadWriteRecipients(targetRecipientWell, [recipientData]);
});
